<template>
    <div>
        <a :href="url" class="txt-img-card__container">
            <div class="txt-img-card__img-bg"></div>
            <div class="txt-img-card__txt-bg">
                <div class="txt-img-card__headline">{{ headline }}</div>
                <div class="txt-img-card__content-subheadline">{{ contentsubheadline }}</div>
                <div class="txt-img-card__txt" v-html="text"></div>
            </div>

            <div class="txt-img-card__img">
                <img :src="image" alt="Background Image">
            </div>
        </a>

    </div>
</template>

<script>
    export default {
        props: {
            className: String,
            headline: String,
            contentsubheadline: String,
            image: String,
            text: String,
            url: String,
        }
    }
</script>
